import { TLegalListItem } from 'shared/types/legalPages.interface';

export const ConsentProcessingLists: TLegalListItem[] = [
  {
    description: 'Collection of account information (such as name, email, and login credentials).',
  },
  {
    description:
      'Collection of technical information (such as IP address, device type, and browser).',
  },
  {
    description: `Use of cookies and similar technologies for authentication, analytics, and improving the 
      platform.`,
  },
  {
    description: `Sharing of information with trusted service providers (such as video hosting, analytics, and 
      payment processors) for the operation of the Services.`,
  },
];
